import { ClassifierDetailView } from '../../api/client'

export function createClassifierDetailsMap(
    classifierDetails: ClassifierDetailView[]
): Map<string, ClassifierDetailView> {
    return new Map(
        classifierDetails.map((classifierDetail) => [classifierDetail.shortName, classifierDetail])
    )
}
